module.exports = __webpack_public_path__ + "static/media/close.99e155c0.svg";